var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossSolidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.261 11.263"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 234",
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 782",
    d: "M.355.355l10.553 10.554"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 783",
    d: "M10.908.353L.354 10.906"
  }))));
}

export default __webpack_public_path__ + "9e86794bc0c9e88f040bdb27c6fd7007.svg";
export { SvgCrossSolidIcon as ReactComponent };